<template>
  <i>
    <div class="nav-wrap">
      <div class="item" v-for="(item, index) in navs" :key="index">
        <a>
          <div
            v-if="haveActive"
            @click="change(item, index)"
            :class="{ active: activeTab === index }"
          >
            {{ item.label ? item.label : item }}
          </div>
          <div
            v-else
            @click="change(item, index)"
            :class="{ active: currentTab === index }"
          >
            {{ item.label ? item.label : item }}
          </div>
        </a>
      </div>
    </div>
    <div class="nav">
      <div class="item" v-for="(item, index) in navs" :key="index">
        <a>
          <div
            v-if="haveActive"
            @click="change(item, index)"
            :class="{ active: activeTab === index }"
          >
            {{ item.label ? item.label : item }}
          </div>
          <div
            v-else
            @click="change(item, index)"
            :class="{ active: currentTab === index }"
          >
            {{ item.label ? item.label : item }}
          </div>
        </a>
      </div>
    </div>
  </i>
</template>

<script>
export default {
  name: "menunav",
  props: {
    navs: {
      type: Array,
    },
    currentTab: {
      default: 0,
    },
    haveActive: {
      default: true,
    },
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  watch: {
    currentTab() {
      this.activeTab = this.currentTab;
    },
  },
  created() {
    this.activeTab = this.currentTab;
    if (this.currentTab === -1) {
      this.activeTab = 0;
    }
  },
  methods: {
    change(item, index) {
      this.activeTab = index;
      if (item.value) {
        item.index = index;
        this.$emit("change", item.value, item);
      } else {
        this.$emit("change", item, index);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

@media screen and (min-width: 1201px) {
  .nav {
    display: none;
  }
  .nav-wrap {
    .item {
      /*background-color: #E91D1D;*/
      // margin-right: 80px;
      height: 30px;
      line-height: 30px;
      a div:hover {
        color: $color-orange;
      }
      .active {
        color: $color-orange;
        padding: 3px 3px;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .nav-wrap {
    display: none;
  }
  .nav {
    display: flex;
    flex-wrap: wrap;
    .item {
      height: 30px;
      line-height: 30px;
      margin: 2px 5px;
      a div:hover {
        color: $color-orange;
      }
      .active {
        color: $color-orange;
        border-bottom: 3px solid $color-orange;
      }
    }
  }
}
</style>